module.exports = __webpack_public_path__ + "img/DIno_1.c3f80918.webp";